import React from "react";

export const TopBar = (props) => {
  return (
    <div id="top-bar">
      <div className="container">
        <div className="top-bar-content">
          <div className="top-bar-left">
            <span className="top-bar-item top-bar-location">
              <i className="fa fa-map-marker"></i> Dubai, UAE
            </span>
            <a href={`mailto:${props.data ? props.data.email : ""}`}>
              <i className="fa fa-envelope"></i> {props.data ? props.data.email : "loading"}
            </a>
          </div>
          <div className="top-bar-right">
            <a className="top-bar-item top-bar-phone" href={`tel:${props.data ? props.data.phone.replace(/\s/g, "") : ""}`}>
              <i className="fa fa-phone"></i> {props.data ? props.data.phone : "loading"}
            </a>
            <div className="top-bar-item top-bar-clock">
              <i className="fa fa-clock-o"></i> {props.data ? props.data.officeHours : "Mon-Fri: 9AM-6PM"}
            </div>
            <div className="top-bar-social">
              <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noopener noreferrer">
                <i className="fa fa-facebook"></i>
              </a>
              <a href={props.data ? props.data.instagram : "/"} target="_blank" rel="noopener noreferrer">
                <i className="fa fa-instagram"></i>
              </a>
              <a href={props.data ? props.data.linkedin : "/"} target="_blank" rel="noopener noreferrer">
                <i className="fa fa-linkedin"></i>
              </a>
              <a href={props.data ? props.data.whatsapp : "/"} target="_blank" rel="noopener noreferrer">
                <i className="fa fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
